<template>
    <v-container id="ficheroalumno-ivt">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    dark
                    color="success"
                    class="alineacentro DatosMatriculado"
                  >
                    <strong>FICHERO DE ALUMNOS</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="6" lg="6">
                  <v-select
                    v-model="filtros.idcarrera"
                    :items="listacarreras"
                    label="Carrera"
                    item-text="carrera"
                    item-value="idcarrera"
                    height="20px"
                    v-on:change="ActualizaGrilla()"
                  />
                </v-col>
                <v-col cols="12" md="4" lg="4">
                  <v-text-field
                    v-model="filtros.apenom"
                    label="Filtro por Apellido o Nombre"
                    height="20px"
                    v-on:keyup.enter="ActualizaGrilla()"
                  />
                </v-col>
                <v-col cols="12" md="2" lg="2">
                  <v-text-field
                    v-model="filtros.nrodoc"
                    label="Filtro por Documento"
                    height="20px"
                    v-on:keyup.enter="ActualizaGrilla()"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="10" lg="10">
                  <v-select
                    v-model="filtros.top"
                    :items="listatop"
                    label="Tope Reg"
                    item-text="topenom"
                    item-value="tope"
                    height="20px"
                    v-on:change="ActualizaGrilla()"
                  />
                </v-col>
                <v-col cols="12" md="2" lg="2">
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Listar"
                    @click="ActualizaGrilla"
                    :disabled="!permisolectura"
                  >
                    <v-icon dark> mdi-magnify </v-icon>
                  </v-btn>
                  <!-- <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Nuevo Alumno"
                    @click="Nueva"
                    :disabled="!permisoescritura"
                  >
                    <v-icon dark> mdi-new-box </v-icon>
                  </v-btn> -->
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-data-table
                    :headers="columnas"
                    :items="lista"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="idalumno"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="Editar(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!item.permiteeditar"
                          >
                            mdi-pencil
                          </v-icon>
                        </template>
                        <span>Editar Estudiante</span>
                      </v-tooltip>
                      <!--
                      &nbsp;&nbsp;
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="resetearclave(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!item.permiteresetearclave"
                          >
                            mdi-account-key
                          </v-icon>
                        </template>
                        <span>Resetear Clave de Usuario</span>
                      </v-tooltip>
                      -->
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ mensajetitulo }}
        </v-card-title>
        <v-card-text>
          {{ mensajecuerpo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="
              dialogmensaje = false;
              if (mensajehome === true) {
                $router.push('Home');
              }
            "
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
      <v-container
        fluid
        class="full-height"
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-row
          align="center"
          justify="center"
          style="height: 100vh"
          no-gutters
          dense
        >
          <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-container>
      </v-dialog>
      <v-dialog v-model="dialogalumno" fullscreen>
        <v-card>
          <v-card-title class="headline">
            {{dialogalumnotitulo}}
          </v-card-title>
          <v-card-actions>
            <v-row row wrap>
              <v-col cols="12" class="alineaderecha">
                <v-btn :disabled="!permisoescritura" color="green darken-1" text @click="Grabar">
                  Grabar
                </v-btn>
                <v-btn
                  color="red darken-1"
                  text
                  @click="dialogalumno = false"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <v-row dense>
              <v-col>
                <v-spacer />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-card class="alineacentro DatosMatriculado">
                <v-card-text>
                  <v-tabs
                    centered
                    color="#4bc47f"
                    dark
                    icons-and-text
                    v-model="tabactivo"
                  >
                    <v-tabs-slider color="#2a6bbf" />
                    <v-tab href="#tab-1" key="Datos">
                      Datos del Alumno
                      <v-icon>mdi-account</v-icon>
                    </v-tab>
                    <v-tab-item value="tab-1">
                      <v-card class="alineacentro DatosMatriculado">
                        <v-card-text>
                          <v-row class="alineaizquierda">
                            <v-col cols="12" md="3" lg="3">
                              <v-select
                                v-model="edited.idtipodoc"
                                :items="listatiposdocumentos"
                                label="Tipo Doc."
                                item-text="nombre"
                                item-value="idtipodoc"
                                height="20px"
                              />
                            </v-col>
                            <v-col cols="12" md="3" lg="3">
                              <v-text-field
                                v-model="edited.nrodoc"
                                label="N° Documento"
                                height="20px"
                                :rules="ReglaRequerido"
                              />
                            </v-col>
                            <v-col cols="12" md="3" lg="3">
                              <v-text-field
                                v-model="edited.apellido"
                                label="Apellidos"
                                height="20px"
                                :rules="ReglaRequerido"
                              />
                            </v-col>
                            <v-col cols="12" md="3" lg="3">
                              <v-text-field
                                v-model="edited.nombre"
                                label="Nombres"
                                height="20px"
                                :rules="ReglaRequerido"
                              />
                            </v-col>
                          </v-row>
                          <v-row class="alineaizquierda">
                            <v-col cols="12" md="3" lg="3">
                              <v-menu
                                v-model="menufecnac"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="fechalocalfecnac"
                                    label="Fecha Nacim."
                                    prepend-icon="mdi-calendar"
                                    v-bind="attrs"
                                    v-on="on"
                                    height="20px"
                                    readonly
                                    :rules="ReglaRequerido"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="edited.fechanac"
                                  @input="menufecnac = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" md="3" lg="3">
                              <v-select
                                v-model="edited.idsexo"
                                :items="listasexos"
                                label="Sexo"
                                item-text="nombre"
                                item-value="idsexo"
                                height="20px"
                              />
                            </v-col>
                            <v-col cols="12" md="3" lg="3">
                              <v-text-field
                                v-model="edited.nacionalidad"
                                label="Nacionalidad"
                                height="20px"
                              />
                            </v-col>
                            <v-col cols="12" md="3" lg="3">
                              <v-select
                                v-model="edited.idestadocivil"
                                :items="listaestadosciviles"
                                label="Est. Civil"
                                item-text="nombre"
                                item-value="idestadocivil"
                                height="20px"
                              />
                            </v-col>
                          </v-row>
                          <v-row class="alineaizquierda">
                            <v-col cols="12" md="6" lg="6">
                              <selector-localidad
                                titulo="Localidad de Nacimiento"
                                ref="sellocnac"
                                :idinicial="edited.idlocalidadnac"
                                @selLocalidad="asignalocalidadnacimiento"
                              ></selector-localidad>
                            </v-col>
                            <v-col cols="12" md="5" lg="5">
                              <v-text-field
                                v-model="edited.domicilio"
                                label="Domicilio"
                                height="20px"
                              />
                            </v-col>
                            <v-col cols="12" md="1" lg="1">
                              <v-text-field
                                v-model="edited.codpostal"
                                label="CP"
                                height="20px"
                              />
                            </v-col>
                          </v-row>
                          <v-row class="alineaizquierda">
                            <v-col cols="12" md="4" lg="4">
                              <selector-localidad
                                titulo="Localidad de Residencia"
                                ref="sellocres"
                                :idinicial="edited.idlocalidad"
                                @selLocalidad="asignalocalidadresidencia"
                              ></selector-localidad>
                            </v-col>
                            <v-col cols="12" md="4" lg="4">
                              <v-text-field
                                v-model="edited.telefono"
                                label="Tel. Fijo"
                                height="20px"
                              />
                            </v-col>
                            <v-col cols="12" md="4" lg="4">
                              <v-text-field
                                v-model="edited.celular"
                                label="Celular"
                                height="20px"
                                :rules="ReglaRequerido"
                              />
                            </v-col>
                          </v-row>
                          <v-row class="alineaizquierda">
                            <v-col cols="12">
                              <v-text-field
                                v-model="edited.emailpersonal"
                                label="Email"
                                height="20px"
                                :rules="ReglaRequerido"
                              />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab href="#tab-2" key="Responsables">
                      Responsables
                      <v-icon>mdi-account-supervisor</v-icon>
                    </v-tab>
                    <v-tab-item value="tab-2">
                      <v-card class="alineacentro DatosMatriculado">
                        <v-card-text>
                          <v-row class="alineaizquierda">
                            <v-col cols="12" class="alineaizquierda">
                              <v-btn
                                class="ma-2"
                                x-small
                                color="blue"
                                title="Nuevo Responsable"
                                @click="NuevoResponsable"
                                :disabled="!permisoescritura"
                              >
                                <v-icon dark> mdi-plus</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-row class="alineaizquierda">
                            <v-col cols="12">
                              <v-data-table
                                :headers="columnasresponsables"
                                :items="edited.responsables"
                                :items-per-page="10"
                                :footer-props="{
                                    'items-per-page-text': 'Filas por Página:',
                                    'items-per-page-all-text': 'Todos',
                                }"
                                item-key="idpersona"
                                class="elevation-1"
                                dense
                                no-data-text="Sin Registros"
                                multi-sort
                              >
                                <template v-slot:item.actions="{ item }">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        small
                                        @click="QuitarResponsable(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="!permisoescritura"
                                    >
                                        mdi-delete
                                    </v-icon>
                                    </template>
                                    <span>Quitar Responsable</span>
                                  </v-tooltip>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-card-text>
                     </v-card>
                    </v-tab-item>
                    <v-tab href="#tab-3" key="Facturacion">
                      Datos para Facturación
                      <v-icon>mdi-account-cash</v-icon>
                    </v-tab>
                    <v-tab-item value="tab-3">
                      <v-card class="alineacentro DatosMatriculado">
                        <v-card-text>
                          <v-row class="alineaizquierda">
                            <v-col cols="12">
                              <v-select
                                v-model="edited.idcondicioniva"
                                :items="listacondicionesiva"
                                label="Cond. Frente a IVA"
                                item-text="nombre"
                                item-value="idcondicioniva"
                                height="20px"
                              />
                            </v-col>
                          </v-row>
                          <v-row class="alineaizquierda">
                            <v-col cols="12">
                              <v-text-field
                                v-model="edited.cuit"
                                label="CUIT/CUIL"
                                height="20px"
                              />
                            </v-col>
                          </v-row>
                          <v-row class="alineaizquierda">
                            <v-col cols="12">
                              <v-text-field
                                v-model="edited.domiciliofiscal"
                                label="Domicilio Fiscal"
                                height="20px"
                              />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab href="#tab-4" key="Novedades">
                      Novedades
                      <v-icon>mdi-badge-account</v-icon>
                    </v-tab>
                    <v-tab-item value="tab-4">
                      <v-card class="alineacentro DatosMatriculado">
                        <v-card-text>
                          <v-row class="alineaizquierda">
                            <v-col cols="12" class="alineaizquierda">
                              <v-btn
                                class="ma-2"
                                x-small
                                color="blue"
                                title="Nueva Novedad"
                                @click="NuevaNovedad"
                                :disabled="!permisoescritura"
                              >
                                <v-icon dark> mdi-plus</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-row class="alineaizquierda">
                            <v-col cols="12">
                              <v-data-table
                                :headers="columnasnovedades"
                                :items="edited.novedades"
                                :items-per-page="10"
                                :footer-props="{
                                    'items-per-page-text': 'Filas por Página:',
                                    'items-per-page-all-text': 'Todos',
                                }"
                                item-key="idpersona"
                                class="elevation-1"
                                dense
                                no-data-text="Sin Registros"
                                multi-sort
                              >
                                <template v-slot:item.actions="{ item }">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                        small
                                        @click="EditarNovedad(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="!permisoescritura"
                                      >
                                        mdi-pencil
                                      </v-icon>
                                    </template>
                                    <span>Editar Novedad</span>
                                  </v-tooltip>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-card-text>
                     </v-card>
                    </v-tab-item>
                    <v-tab href="#tab-5" key="Carreras">
                      Inscripciones
                      <v-icon>mdi-file-document</v-icon>
                    </v-tab>
                    <v-tab-item value="tab-5">
                      <v-card class="alineacentro DatosMatriculado">
                        <v-card-text>
                          <v-row row wrap>
                            <v-col cols="12">
                              <v-data-table
                                :headers="columnasinscripciones"
                                :items="editedver.inscripciones"
                                :items-per-page="10"
                                item-key="idinscripcion"
                                class="elevation-1"
                                dense
                                no-data-text="Sin inscripciones existentes"
                                multi-sort
                                hide-default-footer
                              >
                                <template v-slot:item.estado="{ item }">
                                  <v-chip :color="getcolorestadoinsc(item.idestado)" dark>
                                    <p class="textofilagrilla">{{ item.estado }}</p>
                                  </v-chip>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                        small
                                        @click="VerMatriculaciones(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        mdi-magnify
                                      </v-icon>
                                    </template>
                                    <span>Ver Matriculaciones</span>
                                  </v-tooltip>
                                  &nbsp;&nbsp;
                                  <v-menu
                                    bottom
                                    offset-y
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="!permisoescritura || item.idestado!=1"
                                      >
                                        mdi-delete-circle
                                      </v-icon>
                                    </template>
                                    <v-list>
                                      <v-list-item :disabled="!permisoescritura" key="1" @click="AbreBajarInscripcion(item,1)">
                                        <v-list-item-title>Baja Inscripción y Usuario</v-list-item-title>
                                      </v-list-item>
                                      <v-list-item :disabled="!permisoescritura" key="2" @click="AbreBajarInscripcion(item,2)">
                                        <v-list-item-title>Baja Inscripción sola</v-list-item-title>
                                      </v-list-item>
                                    </v-list>
                                  </v-menu>
                                  &nbsp;&nbsp;
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                        small
                                        @click="ActivarInscripcion(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="!permisoescritura || item.idestado==1"
                                      >
                                        mdi-account-reactivate
                                      </v-icon>
                                    </template>
                                    <span>Activar Inscripción</span>
                                  </v-tooltip>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-text v-if="matriculacionesxinscripcion.length>0">
                          <v-row row wrap>
                            <v-col cols="12">
                              <v-data-table
                                :headers="columnasmatriculaciones"
                                :items="matriculacionesxinscripcion"
                                :items-per-page="10"
                                item-key="idmatriculacion"
                                class="elevation-1"
                                dense
                                no-data-text="Sin matriculaciones existentes"
                                multi-sort
                                hide-default-footer
                              >
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab href="#tab-6" key="Licencias">
                      Licencias
                      <v-icon>mdi-file-document</v-icon>
                    </v-tab>
                    <v-tab-item value="tab-6">
                      <v-card class="alineacentro DatosMatriculado">
                        <v-card-text>
                          <v-row class="alineaizquierda">
                            <v-col cols="12" class="alineaizquierda">
                              <v-btn
                                class="ma-2"
                                x-small
                                color="blue"
                                title="Nueva Licencia"
                                @click="NuevaLicencia"
                                :disabled="!permisoescritura"
                              >
                                <v-icon dark> mdi-plus</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-row row wrap>
                            <v-col cols="12">
                              <v-data-table
                                :headers="columnaslicencias"
                                :items="edited.licencias"
                                :items-per-page="10"
                                :footer-props="{
                                    'items-per-page-text': 'Filas por Página:',
                                    'items-per-page-all-text': 'Todos',
                                }"
                                item-key="idlicencia"
                                class="elevation-1"
                                dense
                                no-data-text="Sin Licencias pre-existentes"
                                multi-sort
                              >
                                <template v-slot:item.actions="{ item }">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                        small
                                        @click="EditarLicencia(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="!permisoescritura"
                                      >
                                        mdi-pencil
                                      </v-icon>
                                    </template>
                                    <span>Editar Licencia</span>
                                  </v-tooltip>
                                  &nbsp;&nbsp;
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        small
                                        @click="AnularLicencia(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="!permisoescritura"
                                    >
                                        mdi-delete
                                    </v-icon>
                                    </template>
                                    <span>Anular Licencia</span>
                                  </v-tooltip>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab href="#tab-7" key="Cuotas">
                      Cuotas
                      <v-icon>mdi-account-cash</v-icon>
                    </v-tab>
                    <v-tab-item value="tab-7">
                      <v-card class="alineacentro DatosMatriculado">
                        <v-card-text>
                          <v-row class="text-center">
                            <v-col cols="12" md="6" lg="6">
                              <v-select
                                v-model="cuotaidcarrera"
                                :items="listacarrerasalumno"
                                label="Carrera"
                                item-text="carrera"
                                item-value="idcarrera"
                                height="20px"
                                v-on:change="seleccionacuotacarrera"
                              />
                            </v-col>
                            <v-col cols="12" md="4" lg="4">
                              <v-select
                                v-model="cuotaanio"
                                :items="listaanioscarreraalumno"
                                label="Año"
                                item-text="anio"
                                item-value="anio"
                                height="20px"
                              />
                            </v-col>
                          </v-row>
                          <v-row class="text-center">
                            <v-col cols="12">
                              <v-data-table
                                :headers="columnascuotas"
                                :items="editedver.cuotas.filter(p=>p.idcarrera===cuotaidcarrera && p.anio===cuotaanio)"
                                :items-per-page="editedver.cuotas.filter(p=>p.idcarrera===cuotaidcarrera && p.anio===cuotaanio).length"
                                hide-default-footer
                                item-key="idcuota"
                                class="elevation-1"
                                dense
                                no-data-text="Sin Registros"
                                multi-sort
                              >
                                <template v-slot:item.estado="{ item }">
                                  <v-chip :color="getcolorestadocuota(item.estado)" dark>
                                    {{ item.estado }}
                                  </v-chip>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
              </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogresponsablenuevo" fullscreen>
        <v-card>
          <v-card-title class="headline">
            Agregando Responsable...
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="GrabarResponsable">
                    Agregar
                </v-btn>
                <v-btn color="red darken-1" text @click="dialogresponsablenuevo = false">
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
              <br />
              <br />
              <v-row>
                <v-col cols="12" md="6" lg="6">
                  <v-card-text class="titulocardchico TituloGrilla2">
                    <strong>DATOS PERSONALES</strong>
                  </v-card-text>
                  <v-card-text>
                    <v-row class="alineaizquierda">
                      <v-col cols="12" md="4" lg="4">
                        <v-select
                            v-model="editedresp.idtipodoc"
                            :items="listatiposdocumentos"
                            label="Tipo Doc."
                            item-text="nombre"
                            item-value="idtipodoc"
                            height="20px"
                            :disabled="respencontrado"
                        />
                      </v-col>
                      <v-col cols="12" md="8" lg="8">
                        <v-text-field
                            v-model="editedresp.nrodoc"
                            label="N° Documento"
                            height="20px"
                            :rules="ReglaRequerido"
                            v-on:keyup.enter="BuscarResponsable"
                            v-on:blur="BuscarResponsable"
                            :disabled="respencontrado"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="alineaizquierda">
                      <v-col cols="12" md="6" lg="6">
                        <v-text-field
                            v-model="editedresp.apellido"
                            label="Apellidos"
                            height="20px"
                            :rules="ReglaRequerido"
                            :disabled="respencontrado"
                        />
                      </v-col>
                      <v-col cols="12" md="6" lg="6">
                        <v-text-field
                            v-model="editedresp.nombre"
                            label="Nombres"
                            height="20px"
                            :rules="ReglaRequerido"
                            :disabled="respencontrado"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="alineaizquierda">
                      <v-col cols="12" md="9" lg="9">
                        <v-select
                            v-model="editedresp.idtipoparentesco"
                            :items="listatiposparentescos"
                            label="Parentesco"
                            item-text="nombre"
                            item-value="idtipoparentesco"
                            height="20px"
                        />
                      </v-col>
                      <v-col cols="12" md="3" lg="3">
                        <v-select
                            v-model="editedresp.conviveconalumno"
                            :items="listaconvive"
                            label="Convive"
                            item-text="item"
                            item-value="item"
                            height="20px"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="alineaizquierda">
                      <v-col cols="12" md="6" lg="6">
                        <v-text-field
                            v-model="editedresp.domicilio"
                            label="Domicilio"
                            height="20px"
                        />
                      </v-col>
                      <v-col cols="12" md="6" lg="6">
                        <v-text-field
                            v-model="editedresp.ocupacion"
                            label="Ocupación"
                            height="20px"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="alineaizquierda">
                      <v-col cols="12">
                        <selector-localidad
                            titulo="Localidad"
                            ref="sellocresponsable"
                            :idinicial="editedresp.idlocalidad"
                            @selLocalidad="asignalocalidadresponsable"
                        ></selector-localidad>
                      </v-col>
                    </v-row>
                    <v-row class="alineaizquierda">
                      <v-col cols="12" md="6" lg="6">
                        <v-text-field
                            v-model="editedresp.telefono"
                            label="Teléfono"
                            height="20px"
                        />
                      </v-col>
                      <v-col cols="12" md="6" lg="6">
                        <v-text-field
                            v-model="editedresp.celular"
                            label="Celular"
                            height="20px"
                        />
                      </v-col>
                      <v-col cols="12" md="6" lg="6">
                        <v-text-field
                            v-model="editedresp.email"
                            label="Email"
                            height="20px"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <v-card-text class="titulocardchico TituloGrilla2">
                    <strong>RESPONSABILIDADES</strong>
                  </v-card-text>
                  <v-card-text>
                    <v-row class="alineaizquierda">
                      <v-col cols="12" md="8" lg="8">
                        <v-select
                            v-model="idresponsabilidadsel"
                            :items="listaresponsabilidades"
                            label="Responsabilidad"
                            item-text="nombre"
                            item-value="idtiporesponsabilidad"
                            height="20px"
                        />
                      </v-col>
                      <v-col cols="12" md="4" lg="4" class="alineaderecha">
                        <v-btn
                            class="ma-2"
                            x-small
                            color="blue"
                            title="Agregar"
                            @click="AgregarResponsabilidad"
                        >
                            <v-icon dark> mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row class="alineaizquierda">
                      <v-col cols="12">
                        <v-data-table
                            :headers="columnasresponsabilidades"
                            :items="editedresp.responsabilidades"
                            :items-per-page="10"
                            :footer-props="{
                                'items-per-page-text': 'Filas por Página:',
                                'items-per-page-all-text': 'Todos',
                            }"
                            item-key="idresponsabilidad"
                            class="elevation-1"
                            dense
                            no-data-text="Sin Registros"
                            multi-sort
                        >
                            <template v-slot:item.actions="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    small
                                    @click="QuitarResponsabilidad(item)"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    mdi-delete
                                </v-icon>
                                </template>
                                <span>Quitar Responsabilidad</span>
                            </v-tooltip>
                            </template>
                            <template v-slot:item.desde="{ item }">
                            {{ fechalocal(item.desde) }}
                            </template>
                            <template v-slot:item.hasta="{ item }">
                            {{ fechalocal(item.hasta) }}
                            </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-text v-if="editedresp.responsabilidades.filter(r=>r.idresponsabilidad===1).length>0" class="titulocardchico TituloGrilla2">
                    <strong>DATOS FISCALES</strong>
                  </v-card-text>
                  <v-card-text v-if="editedresp.responsabilidades.filter(r=>r.idresponsabilidad===1).length>0">
                    <v-row class="alineaizquierda">
                      <v-col cols="12">
                        <v-select
                        v-model="editedresp.idcondicioniva"
                        :items="listacondicionesiva"
                        label="Cond. Frente a IVA"
                        item-text="nombre"
                        item-value="idcondicioniva"
                        height="20px"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="alineaizquierda">
                      <v-col cols="12">
                        <v-text-field
                        v-model="editedresp.cuit"
                        label="CUIT/CUIL"
                        height="20px"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="alineaizquierda">
                      <v-col cols="12">
                        <v-text-field
                        v-model="editedresp.domiciliofiscal"
                        label="Domicilio Fiscal"
                        height="20px"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-col>
              </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialognuevanovedad" persistent max-width="700">
        <v-card>
          <v-card-title class="headline">
            Agregando Novedad...
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="GrabarNovedad">
                    Grabar
                </v-btn>
                <v-btn color="red darken-1" text @click="dialognuevanovedad = false">
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
              <br />
              <br />
              <v-row>
                <v-col cols="12" md="6" lg="6">
                  <v-select
                    v-model="editednov.idtiponovedad"
                    :items="listatiposnovedades"
                    label="Tipo Novedad"
                    item-text="novedad"
                    item-value="idtiponovedad"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-menu
                    v-model="menufnovdesde"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fechalocalfdesde"
                        label="Desde"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        height="20px"
                        readonly
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editednov.desde"
                      @input="menufnovdesde = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-menu
                    v-model="menufnovhasta"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fechalocalfhasta"
                        label="Hasta"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        height="20px"
                        readonly
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editednov.hasta"
                      @input="menufnovhasta = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editednov.observacion"
                    label="Observación"
                    height="20px"
                  />
                </v-col>
              </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialoglicencia" persistent max-width="700">
        <v-card>
          <v-card-title class="headline">
            {{ dialoglicenciatitulo }}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="GrabarLicencia">
                    Grabar
                </v-btn>
                <v-btn color="red darken-1" text @click="dialoglicencia = false">
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
              <br />
              <br />
              <v-row>
                <v-col cols="12" md="6" lg="6">
                  <v-select
                    v-model="editedlic.idtipolicencia"
                    :items="listatiposlicencia"
                    label="Tipo Licencia"
                    item-text="nombre"
                    item-value="idtipolicencia"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-menu
                    v-model="menulicdesde"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fechalocallicdesde"
                        label="Desde"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        height="20px"
                        readonly
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="editedlic.desde"
                        @input="menulicdesde = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-menu
                    v-model="menulichasta"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fechalocallichasta"
                        label="Hasta"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        height="20px"
                        readonly
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="editedlic.hasta"
                        @input="menulichasta = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedlic.observacion"
                    label="Observaciones"
                    height="20px"
                  />
                </v-col>
              </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogbajainscripcion" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h5">
            Baja de Inscripción
          </v-card-title>
          <v-card-text>
            Seleccione el tipo de baja:
            <br />
            <v-select
              v-model="bajainsc.idtipobaja"
              :items="listatiposbajasinscripciones"
              label="Tipo"
              item-text="nombre"
              item-value="idestado"
              height="20px"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="BajarInscripcion"
            >
              Aceptar
            </v-btn>
            <v-btn
              color="red darken-1"
              text
              @click="dialogbajainscripcion = false"
            >
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
import SelectorLocalidad from "../../components/SelectorLocalidad.vue";
export default {
  name: "ficheroalumno",
  components: {
    ConfirmDlg: ConfirmDlg,
    SelectorLocalidad
  },
  data() {
    return {
      loading: false,
      usuario: '',
      permisolectura: false,
      permisoescritura: false,
      idrol: 0,
      roles: [],
      nromodulo: 13,
      dialogmensaje: false,
      mensajetitulo: '',
      mensajecuerpo: '',
      mensajehome: false,
      listacarreras: [],
      filtros: {
        idcarrera: 1,
        apenom: '',
        nrodoc: '',
        usuario: '',
        top: 100
      },
      columnas: [
        {
          text: "Op.",
          value: "actions",
          sortable: false,
          width: 80,
        },
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idalumno",
          width: 70,
        },
        {
          text: "Carrera Actual",
          align: "center",
          sortable: true,
          value: "carrera",
          width: 120,
        },
        {
          text: "Año Ing.",
          align: "center",
          sortable: true,
          value: "anioingreso",
          width: 100,
        },
        {
          text: "Apellido",
          align: "center",
          sortable: true,
          value: "apellido",
          width: 100,
        },
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
          width: 100,
        },
        {
          text: "Cod Sis Ant",
          align: "center",
          sortable: true,
          value: "codigoanterior",
          width: 120,
        },
        {
          text: "N° Doc",
          align: "center",
          sortable: true,
          value: "nrodoc",
          width: 90,
        },
        {
          text: "F Nac",
          align: "center",
          sortable: true,
          value: "fechanacdmy",
          width: 90,
        },
        {
          text: "Localidad",
          align: "center",
          sortable: true,
          value: "localidad",
          width: 100,
        },
        {
          text: "Email Instit.",
          align: "center",
          sortable: true,
          value: "emailinstitucional",
          width: 140,
        }
      ],
      lista: [],
      edited: {
        idalumno: 0,
        legajo: 0,
        idestado: 0,
        apellido: '',
        celular: '',
        codanterior: 0,
        codpostal: '',
        domicilio: '',
        emailpersonal: '',
        emailinstitucional: '',
        fechanac: '',
        idestadocivil: 0,
        idlocalidad: 0,
        idlocalidadnac: 0,
        idsexo: 0,
        idtipodoc: 0,
        nacionalidad: '',
        nombre: '',
        nrodoc: '',
        telefono: '',
        cuit: 0,
        domiciliofiscal: '',
        idcondicioniva: 0,
        responsables: [],
        novedades: [],
        licencias: [],
        usuario: ''
      },
      editedver: {
        inscripciones: [],
        matriculaciones: [],
        cuotas: []
      },
      dialogalumno: false,
      tabactivo: 'Datos',
      ReglaRequerido: [
        v => !!v || 'Requerido'
      ],
      columnasresponsables: [
        {
          text: "Op.",
          value: "actions",
          width: 75
        },
        {
          text: "DNI",
          align: "center",
          sortable: true,
          value: "nrodoc",
          width: 110
        },
        {
          text: "Apellido",
          align: "center",
          sortable: true,
          value: "apellido",
          width: 150
        },
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
          width: 150
        },
        {
          text: "Parentesco",
          align: "center",
          sortable: true,
          value: "tipoparentesco",
          width: 120
        },
        {
          text: "Respons.",
          align: "center",
          sortable: true,
          value: "responsabilidad",
          width: 140
        },
        {
          text: "Celular",
          align: "center",
          sortable: true,
          value: "celular",
          width: 90
        },
        {
          text: "Email",
          align: "center",
          sortable: true,
          value: "email",
          width: 120
        },
        {
          text: "Desde",
          align: "center",
          sortable: true,
          value: "activodesdedmy",
          width: 90
        },
        {
          text: "Hasta",
          align: "center",
          sortable: true,
          value: "activohastadmy",
          width: 90
        }
      ],
      listatiposparentescos: [],
      listaconvive: ['SI', 'NO'],
      idresponsabilidadsel: '',
      listaresponsabilidades: [],
      columnasresponsabilidades: [
        {
          text: "Op.",
          value: "actions",
          width: 40
        },
        {
          text: "Responsabilidad",
          align: "center",
          sortable: true,
          value: "responsabilidad",
          width: 150
        },
        {
          text: "Desde",
          align: "center",
          sortable: true,
          value: "desde",
          width: 90
        },
        {
          text: "Hasta",
          align: "center",
          sortable: true,
          value: "hasta",
          width: 90
        },
        {
          text: "Activo",
          align: "center",
          sortable: true,
          value: "activostr",
          width: 90
        }
      ],
      dialogresponsablenuevo: false,
      respencontrado: false,
      listasexos: [],
      listaestadosciviles: [],
      listacondicionesiva: [],
      menufecnac: false,
      editedresp:{
        idpersona: 0,
        idtipodoc: 0,
        nrodoc: '',
        apellido: '',
        nombre: '',
        idparentesco: 0,
        conviveconalumno: '',
        ocupacion: '',
        domicilio: '',
        idlocalidad: 0,
        telefono: '',
        celular: '',
        email: '',
        idcondicioniva: 0,
        cuit: '',
        domiciliofiscal: '',
        responsabilidades: []
      },
      listatiposdocumentos: [],
      columnasinscripciones: [
        {
          text: "Op.",
          value: "actions",
          width: 75
        },
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idinscripcion",
          width: 90
        },
        {
          text: "Carrera",
          align: "center",
          sortable: true,
          value: "carrera",
          width: 120
        },
        {
          text: "Sede",
          align: "center",
          sortable: true,
          value: "sede",
          width: 120
        },
        {
          text: "Año Ing",
          align: "center",
          sortable: true,
          value: "anioingreso",
          width: 120
        },
        {
          text: "F. Insc",
          align: "center",
          sortable: true,
          value: "fechainscripciondmy",
          width: 120
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estado",
          width: 100
        },
        {
          text: "F. Estado",
          align: "center",
          sortable: true,
          value: "fechacambioestadodmy",
          width: 120
        }
      ],
      dialogalumnotitulo: '',
      columnasnovedades: [
        {
          text: "Op.",
          value: "actions",
          width: 75
        },
        {
          text: "ID Nov",
          align: "center",
          sortable: true,
          value: "idnovedad",
          width: 90
        },
        {
          text: "Novedad",
          align: "center",
          sortable: true,
          value: "tiponovedad",
          width: 130
        },
        {
          text: "Desde",
          align: "center",
          sortable: true,
          value: "desdedmy",
          width: 90
        },
        {
          text: "Hasta",
          align: "center",
          sortable: true,
          value: "hastadmy",
          width: 90
        },
        {
          text: "Obs.",
          align: "center",
          sortable: true,
          value: "observacion",
          width: 120
        }
      ],
      dialognuevanovedad: false,
      menufnovdesde: false,
      menufnovhasta: false,
      editednov: {
        idnovedad: 0,
        idtiponovedad: 0,
        observacion: '',
        desde: '',
        hasta: ''
      },
      listatiposnovedades: [],
      listatop: [{tope: 0, topenom: 'TODOS'},{tope: 50, topenom: '50'},{tope: 100, topenom: '100'},{tope: 200, topenom: '200'},{tope: 300, topenom: '300'},{tope: 500, topenom: '500'},{tope: 1000, topenom: '1000'}],
      columnaslicencias: [
        {
          text: "Op.",
          value: "actions",
          width: 75
        },
        {
          text: "ID Lic",
          align: "center",
          sortable: true,
          value: "idlicencia",
          width: 90
        },
        {
          text: "Tipo",
          align: "center",
          sortable: true,
          value: "tipolicencia",
          width: 100
        },
        {
          text: "Desde",
          align: "center",
          sortable: true,
          value: "desdedmy",
          width: 90
        },
        {
          text: "Hasta",
          align: "center",
          sortable: true,
          value: "hastadmy",
          width: 90
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estado",
          width: 90
        }
      ],
      editedlic: {
        id: 0,
        idlicencia: 0,
        idtipolicencia: 0,
        desde: '',
        hasta: '',
        observacion: ''
      },
      dialoglicencia: false,
      dialoglicenciatitulo: '',
      listatiposlicencia: [],
      menulicdesde: false,
      menulichasta: false,
      matriculacionesxinscripcion: [],
      columnasmatriculaciones: [
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idmatriculacion",
          width: 90
        },
        {
          text: "Carrera",
          align: "center",
          sortable: true,
          value: "carrera",
          width: 120
        },
        {
          text: "Sede",
          align: "center",
          sortable: true,
          value: "sede",
          width: 120
        },
        // {
        //   text: "Año Ing",
        //   align: "center",
        //   sortable: true,
        //   value: "anioingreso",
        //   width: 120
        // },
        {
          text: "Año Matrícula",
          align: "center",
          sortable: true,
          value: "aniomatricula",
          width: 120
        }
      ],
      listatiposbajasinscripciones: [{idestado: 3, nombre: 'Finalizada'},{idestado: 4, nombre: 'Baja'},{idestado: 5, nombre: 'Egreso'}],
      dialogbajainscripcion: false,
      bajainsc: {
        idtipobaja: 4,
        tipobaja: 0,
        idinscripcion: 0
      },
      listacarrerasalumno: [],
      columnascuotas: [
        {
          text: "Tipo",
          align: "center",
          sortable: true,
          value: "tipocuota",
          width: 90,
        },
        {
          text: "Carrera",
          align: "center",
          sortable: true,
          value: "carrera",
          width: 100,
        },
        {
          text: "Año",
          align: "center",
          sortable: true,
          value: "anio",
          width: 80,
        },
        {
          text: "N°",
          align: "center",
          sortable: true,
          value: "nrocuota",
          width: 90,
        },
        {
          text: "Cuota",
          align: "center",
          sortable: true,
          value: "cuota",
          width: 120,
        },
        {
          text: "Venc 1",
          align: "center",
          sortable: true,
          value: "fechavenc1dmy",
          width: 90,
        },
        {
          text: "Monto",
          align: "center",
          sortable: true,
          value: "montocuota",
          width: 90,
        },
        {
          text: "N° Comp.",
          align: "center",
          sortable: true,
          value: "factura",
          width: 90,
        },
        {
          text: "F. Fact",
          align: "center",
          sortable: true,
          value: "fechafactura",
          width: 100,
        },
        {
          text: "Monto",
          align: "center",
          sortable: true,
          value: "montofactura",
          width: 90,
        },
        {
          text: "F. Pago",
          align: "center",
          sortable: true,
          value: "fechapago",
          width: 100,
        },
        {
          text: "Monto Rec",
          align: "center",
          sortable: true,
          value: "montorecibo",
          width: 110,
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estado",
          width: 100,
        }
      ],
      cuotaanio: 0,
      listaanioscarreraalumno: [],
    };
  },
  mounted() {
    this.loading = true;
    this.roles=[];
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
        this.loading = false;
        this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
        this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
        this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 3).length > 0 ? true : false;
        var parametro= {anio: 0};
        axios.post("inscripcioncarrera/PostCarrerasActivas", parametro, { headers: { "Content-Type": "application/json",}}).then((result) => {
          if(result.data.resultado===0){
            if(this.roles.includes(6) || this.roles.includes(8))
            {
              this.listacarreras = result.data.datos.filter(c=> c.idnivel===3);
            }else{
              this.listacarreras = result.data.datos;
              this.listacarreras.splice(0,0,{idcarrera:0, carrera: 'TODAS', anioimplementa: 0, idsede: 0, sede: '', normativa: '', anioingreso: 0, idnivel: 0, nivel: ''});
            }
            this.filtros.idcarrera= this.listacarreras.length>0 ? this.listacarreras[0].idcarrera : 0;
            //this.ActualizaGrilla();
            this.loading=false;
          }else{
            this.loading = false;
            this.MostrarMensaje('Error', result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje('Error', error, false);
        });
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    fechaFormatoYMD(date) {
      return (date.getFullYear() + "-" + ((date.getMonth() + 1).toString().length != 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-" + (date.getDate().toString().length != 2 ? "0" + date.getDate() : date.getDate()));
    },
    fechaFormatoDMY(date,sumadia) {
      return ((date.getDate().toString().length != 2 ? "0" + (date.getDate()+sumadia).toString() : (date.getDate()+sumadia).toString()) + '/' + ((date.getMonth() + 1).toString().length != 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + '/' + date.getFullYear().toString());
    },
    CompletarCombos (nueva, item) {
      axios.get("referenciales/tiposdocumento").then((result) => {
        if(result.data.resultado===0){
          this.listatiposdocumentos = result.data.datos;
          axios.get("referenciales/sexo").then((result) => {
            if(result.data.resultado===0){
              this.listasexos = result.data.datos;
              axios.get("referenciales/estadocivil").then((result) => {
                if(result.data.resultado===0){
                  this.listaestadosciviles = result.data.datos;
                  axios.get("referenciales/condicioniva").then((result) => {
                    if(result.data.resultado===0){
                      this.listacondicionesiva = result.data.datos;
                      axios.get("referenciales/tipoparentesco").then((result) => {
                        if(result.data.resultado===0){
                          this.listatiposparentescos = result.data.datos;
                          axios.get("referenciales/responsabilidades").then((result) => {
                            if(result.data.resultado===0) {
                              this.listaresponsabilidades = result.data.datos;
                              axios.get("referenciales/tiponovedad").then((result) => {
                                if(result.data.resultado===0) {
                                  this.listatiposnovedades= result.data.datos;
                                  axios.get("referenciales/tipolicencia").then((result) => {
                                    if(result.data.resultado===0) {
                                      this.listatiposlicencia= result.data.datos;
                                      if(nueva===true){
                                        this.ContinuaNueva();
                                      }else{
                                        this.ContinuarEdit(item);
                                      }
                                    }else{
                                      this.loading = false;
                                      this.MostrarMensaje('Error', result.data.resultadomensaje, false);
                                    }
                                  }).catch((error) => {
                                    this.loading = false;
                                    this.MostrarMensaje('Error', error, false);
                                  });
                                }else{
                                  this.loading = false;
                                  this.MostrarMensaje('Error', result.data.resultadomensaje, false);
                                }
                              }).catch((error) => {
                                this.loading = false;
                                this.MostrarMensaje('Error', error, false);
                              });
                            }else{
                              this.loading = false;
                              this.MostrarMensaje('Error', result.data.resultadomensaje, false);
                            }
                          }).catch((error) => {
                            this.loading = false;
                            this.MostrarMensaje('Error', error, false);
                          });
                        } else {
                          this.loading = false;
                          this.MostrarMensaje('Error', result.data.resultadomensaje, false);
                        }
                      }).catch((error) => {
                        this.loading = false;
                        this.MostrarMensaje('Error', error, false);
                      });
                    }else{
                      this.loading = false;
                      this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
                    }
                  }).catch((error) => {
                    this.loading = false;
                    this.MostrarMensaje('Error', error, false);
                  });
                }else{
                  this.loading = false;
                  this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
                }
              }).catch((error) => {
                this.loading = false;
                this.MostrarMensaje('Error', error, false);
              });
            }else{
                this.loading = false;
                this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje('Error', error, false);
          });
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    },
    ActualizaGrilla () {
      this.loading=true;
      var param= JSON.stringify({idcarrera: parseInt(this.filtros.idcarrera), apenom: this.filtros.apenom, nrodoc: this.filtros.nrodoc, usuario: this.usuario, top: this.filtros.top });
      axios.post("administracion/PostListaAlumnos", param, { headers: {"Content-Type": "application/json", }})
        .then((result) => {
          if(result.data.resultado===0){
            this.lista = result.data.datos;
            this.loading=false;
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
      })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
      });
    },
    Editar (item) {
      this.loading=true;
      this.tabactivo= 'Datos';
      this.dialogalumnotitulo='Editando al Estudiante ID:' + item.idalumno.toString() + ' - ' + item.apellido + ' ' + item.nombre;
      this.edited= {
        idalumno: 0,
        legajo: 0,
        idestado: 0,
        apellido: '',
        celular: '',
        codanterior: 0,
        codpostal: '',
        domicilio: '',
        emailpersonal: '',
        emailinstitucional: '',
        fechanac: '',
        idestadocivil: 0,
        idlocalidad: 0,
        idlocalidadnac: 0,
        idsexo: 0,
        idtipodoc: 0,
        nacionalidad: '',
        nombre: '',
        nrodoc: '',
        telefono: '',
        cuit: 0,
        domiciliofiscal: '',
        idcondicioniva: 0,
        responsables: [],
        novedades: [],
        licencias: [],
        usuario: ''
      };
      this.matriculacionesxinscripcion=[];
      this.CompletarCombos(false,item);
    },
    ContinuarEdit(item) {
      var param= JSON.stringify({idalumno: item.idalumno });
      axios.post("administracion/PostGetAlumno", param, { headers: {"Content-Type": "application/json", }})
        .then((result) => {
          if(result.data.resultado===0){
            this.edited= result.data.datos[0];
            this.editedver= result.data.datos[1];
            this.edited.usuario= this.usuario;

            axios.get('alumno/carrerasalumno/0/ /' + item.idalumno.toString() + '/0').then((result) => {
              if(result.data.resultado===0) {
                this.listacarrerasalumno = result.data.datos;
                if(this.listacarrerasalumno.length>0) {
                  this.cuotaidcarrera=this.listacarrerasalumno[0].idcarrera;
                  var ia= 0;
                  var anioactual= (new Date()).getFullYear()+1;
                  this.listaanioscarreraalumno=[];
                  var anioing= this.listacarrerasalumno.filter(c=> c.idcarrera===this.cuotaidcarrera)[0].anioingreso;
                  if(anioing<=anioactual){
                    for(ia=anioing;ia<=anioactual;ia++){
                      this.listaanioscarreraalumno.push({anio: ia});
                    }
                  }else{
                    for(ia=anioactual;ia<=anioing+1;ia++){
                      this.listaanioscarreraalumno.push({anio: ia});
                    }
                  }
                  this.cuotaanio= (new Date()).getFullYear();
                  this.loading = false;
                  this.dialogalumno= true;
                }
              }else{
                this.loading = false;
                this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.MostrarMensaje('Error', error, false);
            });
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
      })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
      });
    },
    Grabar () {
      this.edited.cuit= this.edited.cuit!=null ? this.edited.cuit.toString() : '';
      this.edited.domiciliofiscal= this.edited.domiciliofiscal!=null ? this.edited.domiciliofiscal : '';
      this.edited.idcondicioniva= this.edited.idcondicioniva!=null && this.edited.idcondicioniva!='' ? this.edited.idcondicioniva : 0;
      this.edited.cuit= this.edited.cuit.length>0 ? parseInt(this.edited.cuit) : 0;
      this.edited.codigoanterior= this.edited.codigoanterior!=null && this.edited.codigoanterior.length>0 ? parseInt(this.edited.codigoanterior) : 0;
      const alumno = JSON.stringify(this.edited);
      axios.post("administracion/PostGrabaAlumno", alumno, { headers: {"Content-Type": "application/json", }}).then((result) => {
        if(result.data.resultado===0){
          this.dialogalumno= false;
          this.ActualizaGrilla();
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
      });
    },
    NuevoResponsable () {
      this.respencontrado=false;
      var idnuevo= this.edited.responsables.length>0 ? this.edited.responsables[this.edited.responsables.length-1].id+1 : 1;
      this.editedresp= {
        id: idnuevo,
        idpersona: 0,
        idtipodoc: 0,
        nrodoc: '',
        apellido: '',
        nombre: '',
        idtipoparentesco: 0,
        conviveconalumno: 'SI',
        ocupacion: '',
        domicilio: '',
        idlocalidad: 0,
        telefono: '',
        celular: '',
        email: '',
        idcondicioniva: 0,
        cuit: 0,
        domiciliofiscal: '',
        responsabilidades: [],
      };
      this.dialogresponsablenuevo= true;
    },
    async QuitarResponsable (item) {
      if (await this.$refs.confirm.open('Confirmar Anulación de Responsable','Esta seguro de querer anular al responsable?')) {
        // item.activo = false;
        // item.activostr='BAJA';
        // item.activohasta= this.fechaFormatoYMD(new Date());
        //this.edited.responsables.splice(this.edited.responsables.indexOf(item), 1);
        item.activo= false;
        item.activostr='BAJA';
        item.activohasta= this.fechaFormatoYMD(new Date());
        item.activohastadmy= this.fechaFormatoDMY(new Date(),0);

        var i=0;
        for(i=0; i<item.responsabilidades.length;i++){
            item.responsabilidades[i].hasta= this.fechaFormatoYMD(new Date());
            item.responsabilidades[i].activo= false;
            item.responsabilidades[i].activostr= 'BAJA';
        }
      }
    },
    GrabarResponsable () {
      this.editedresp.cuit= this.editedresp.cuit!=null ? parseInt(this.editedresp.cuit) : 0;
      var resp='';
      var i=0;
      for(i=0; i<this.editedresp.responsabilidades.length;i++){
        resp= resp.length>0 ? resp + '|' + this.editedresp.responsabilidades[i].responsabilidad : this.editedresp.responsabilidades[i].responsabilidad;
      }
      var validores= this.ValidarResponsable();
      if(validores==='OK'){
        this.edited.responsables.push({id: this.editedresp.id, idpersona: this.editedresp.idpersona,idtipodoc: this.editedresp.idtipodoc,nrodoc: this.editedresp.nrodoc, apellido: this.editedresp.apellido, nombre: this.editedresp.nombre, domicilio: this.editedresp.domicilio,idlocalidad: this.editedresp.idlocalidad, idtipoparentesco: this.editedresp.idtipoparentesco, tipoparentesco: this.listatiposparentescos.filter(p=> p.idtipoparentesco===this.editedresp.idtipoparentesco)[0].nombre,conviveconalumno: this.editedresp.conviveconalumno, ocupacion: this.editedresp.ocupacion, telefono: this.editedresp.telefono, celular: this.editedresp.celular, email: this.editedresp.email,idcondicioniva: this.editedresp.idcondicioniva,domiciliofiscal: this.editedresp.domiciliofiscal,cuit: this.editedresp.cuit, activo: true, activostr: 'ACTIVO', activodesde: this.fechaFormatoYMD(new Date()),activodesdedmy:'', activohasta: '',activohastadmy: '', responsabilidades: this.editedresp.responsabilidades, responsabilidad: resp});
        this.dialogresponsablenuevo= false;
      }else{
        this.MostrarMensaje('Error', validores, false);
      }
    },
    ValidarResponsable () {
      var valido='OK';
      return valido;
    },
    BuscarResponsable () {
      this.loading=true;
      var doc=  this.editedresp.nrodoc!=null && this.editedresp.nrodoc!='' ?  this.editedresp.nrodoc : ' ';
      var user= this.usuario!=null && this.usuario.length>0 ? this.usuario : ' ';
      axios.get("alumno/buscaresponsable/" + doc + '/' + user + '/0').then((result) => {
        if(result.data.resultado===0){
            if(result.data.datos.length>0){
            var per=result.data.datos[0];
            this.editedresp.idpersona= per.idpersona;
            this.editedresp.idtipodoc= per.idtipodoc;
            this.editedresp.apellido= per.apellido;
            this.editedresp.nombre= per.nombre;
            this.editedresp.ocupacion= per.ocupacion;
            this.editedresp.domicilio= per.domicilio;
            this.editedresp.idlocalidad= per.idlocalidad;
            this.editedresp.telefono= per.telefono;
            this.editedresp.celular= per.celular;
            this.editedresp.email= per.emailpersonal;
            this.editedresp.idcondicioniva= parseInt(per.idcondicioniva);
            this.editedresp.cuit= per.cuit;
            this.editedresp.domiciliofiscal= per.domiciliofiscal;
            if(this.$refs.sellocresponsable!=null){
                if(per.idlocalidad!=null && per.idlocalidad!=0) {
                this.$refs.sellocresponsable.id= per.idlocalidad;
                this.$refs.sellocresponsable.BuscarRegistro();
                }else{
                this.$refs.sellocresponsable.QuitarRegistro();
                }
            }
            this.respencontrado=true;
            }
            this.loading=false;
        }else{
            if(this.$refs.sellocresponsable!=null){
            this.$refs.sellocresponsable.QuitarRegistro();
            }
            this.loading=false;
            this.MostrarMensaje('Error', result.data.resultadomensaje,false);
        }
      }).catch((error) => {
        if(this.$refs.sellocresponsable!=null) {
          this.$refs.sellocresponsable.QuitarRegistro();
        }
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    },
    AgregarResponsabilidad () {
      if(this.idresponsabilidadsel!=null && this.idresponsabilidadsel!=0){
        this.editedresp.responsabilidades.push({idresponsabilidad: this.idresponsabilidadsel, responsabilidad: this.listaresponsabilidades.filter(r=> r.idtiporesponsabilidad===this.idresponsabilidadsel)[0].nombre, desde: this.fechaFormatoYMD(new Date()), hasta: '', activo: true, activostr: 'ACTIVO'});
      }
    },
    QuitarResponsabilidad (item) {
      this.editedresp.responsabilidades.splice(this.editedresp.responsabilidades.indexOf(item), 1);
    },
    fechalocal: function (pfecha) {
      if (pfecha != null && pfecha != "") {
        var fecha = new Date(pfecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    asignalocalidadnacimiento(value) {
      this.edited.idlocalidadnac = value != null ? value.idlocalidad : 0;
    },
    asignalocalidadresidencia(value) {
      this.edited.idlocalidad = value != null ? value.idlocalidad : 0;
    },
    asignalocalidadresponsable (value) {
      this.editedresp.idlocalidad = value != null ? value.idlocalidad : 0;
    },
    NuevaNovedad () {
      var idnuevo= this.edited.novedades.length>0 ? this.edited.novedades[this.edited.novedades.length-1].id+1 : 1;
      this.editednov= {
        nuevo: true,
        id: idnuevo,
        idnovedad: 0,
        idtiponovedad: 0,
        observacion: '',
        desde: this.fechaFormatoYMD(new Date()),
        hasta: ''
      };
      this.dialognuevanovedad= true;
    },
    EditarNovedad (item) {
      this.editednov= {
        nuevo: false,
        id: item.id,
        idnovedad: item.idnovedad,
        idtiponovedad: item.idtiponovedad,
        observacion: item.observacion,
        desde: item.desde,
        hasta: item.hasta
      };
      this.dialognuevanovedad= true;
    },
    GrabarNovedad () {
      if(this.editednov.idtiponovedad!=null && this.editednov.idtiponovedad!=''){
        if(this.editednov.desde!=null && this.editednov.desde!=''){
          if(this.edited.novedades.filter(n=> n.idtiponovedad===this.editednov.idtiponovedad && n.hasta.length===0 && n.id!=this.editednov.id).length===0){
            if(this.editednov.nuevo===true) {
                this.edited.novedades.push({id: this.editednov.id,idnovedad: this.editednov.idnovedad, idtiponovedad: this.editednov.idtiponovedad,tiponovedad: this.listatiposnovedades.filter(t=> t.idtiponovedad===this.editednov.idtiponovedad)[0].novedad, observacion: this.editednov.observacion,desde: this.editednov.desde,desdedmy: this.fechaFormatoDMY(new Date(this.editednov.desde),1), hasta: this.editednov.hasta, hastadmy: this.editednov.hasta.length>0 ? this.fechaFormatoDMY(new Date(this.editednov.hasta),1) : '' });
            }else{
                var nov=this.edited.novedades.filter(n=> n.id===this.editednov.id)[0];
                nov.idtiponovedad= this.editednov.idtiponovedad;
                nov.tiponovedad= this.listatiposnovedades.filter(t=> t.idtiponovedad===this.editednov.idtiponovedad)[0].novedad;
                nov.desde= this.editednov.desde;
                nov.desdedmy= this.fechaFormatoDMY(new Date(nov.desde),1);
                nov.hasta= this.editednov.hasta;
                nov.hastadmy= nov.hasta.length>0 ? this.fechaFormatoDMY(new Date(nov.hasta),1) : '';
                nov.observacion= this.editednov.observacion;
            }
            this.dialognuevanovedad= false;
          }else{
            this.MostrarMensaje('Error', 'Ya existe una novedad del mismo tipo activa!',false);
          }
        }else{
          this.MostrarMensaje('Error', 'Debe ingresar la fecha desde',false);
        }
      }else{
        this.MostrarMensaje('Error', 'Debe seleccionar el tipo de novedad',false);
      }
    },
    NuevaLicencia () {
      this.dialoglicenciatitulo= 'Nueva Licencia';
      this.editedlic= {
        id: this.edited.licencias.length>0 ? this.edited.licencias[this.edited.licencias.length-1].id + 1 : 1,
        idlicencia: 0,
        idtipolicencia: 0,
        desde: '',
        hasta: '',
        observacion: ''
      };
      this.dialoglicencia= true;
    },
    EditarLicencia (item) {
      this.dialoglicenciatitulo= 'Editando Licencia ID ' + item.idlicencia;
      this.editedlic= {
        id: item.id,
        idlicencia: item.idlicencia,
        idtipolicencia: item.idtipolicencia,
        desde: item.desdeymd,
        hasta: item.hastaymd,
        observacion: item.observacion
      };
      this.dialoglicencia= true;
    },
    async AnularLicencia (item) {
      if (await this.$refs.confirm.open('Confirmar Anulación de Licencia','Esta seguro de querer anular la licencia?')) {
        this.edited.licencias.splice(this.edited.licencias.indexOf(item), 1);
      }
    },
    GrabarLicencia () {
      var valida='';
      if(this.editedlic.idtipolicencia===null || this.editedlic.idtipolicencia==='' || this.editedlic.idtipolicencia===0){
        valida= 'Debe seleccionar el tipo de licencia';
      }
      if(this.editedlic.desde===null || this.editedlic.desde===''){
        valida= 'Debe ingresar fecha desde de la licencia';
      }
      if(this.edited.licencias.filter(l=> l.idestado===1 && (l.hastaymd===null || l.hastaymd==='') && l.id!=this.editedlic.id).length>0){
        valida= 'Ya existe una licencia activa abierta.';
      }
      if(this.edited.licencias.filter(l=> l.idestado===1 && this.editedlic.desde>=l.desdeymd && this.editedlic.desde<=l.hastaymd && l.id!=this.editedlic.id).length>0){
        valida= 'La licencia que desea crear cae en periodo de otra licencia.';
      }
      if(valida===''){
        if(this.editedlic.idlicencia===0){
          this.edited.licencias.push({id: this.editedlic.id,idlicencia: 0, idtipolicencia: this.editedlic.idtipolicencia, tipolicencia: this.listatiposlicencia.filter(l=> l.idtipolicencia===this.editedlic.idtipolicencia)[0].nombre, desdedmy: this.fechaFormatoDMY(new Date(this.editedlic.desde),1), desdeymd: this.editedlic.desde , hastadmy: this.editedlic.hasta.length>0 ? this.fechaFormatoDMY(new Date(this.editedlic.hasta),1) : '', hastaymd: this.editedlic.hasta,idestado: 1, estado: 'Activa', observacion: this.editedlic.observacion, idusuariocarga: 0, usuario: this.usuario, feccargadmy: '', feccargaymd: '' });
        }else{
          var lic= this.edited.licencias.filter(l=> l.id===this.editedlic.id)[0];
          lic.desdeymd= this.editedlic.desde;
          lic.desdedmy= this.fechaFormatoDMY(new Date(this.editedlic.desde),1);
          lic.hastaymd= this.editedlic.hasta;
          lic.hastadmy= this.fechaFormatoDMY(new Date(this.editedlic.hasta),1);
          lic.idtipolicencia= this.editedlic.idtipolicencia;
          lic.observacion= this.editedlic.observacion;
        }
        this.dialoglicencia= false;
      }else{
        this.MostrarMensaje('Error', valida, false);
      }
    },
    VerMatriculaciones (item) {
      this.matriculacionesxinscripcion = this.editedver.matriculaciones.filter(m=> m.idinscripcion===item.idinscripcion)
    },
    AbreBajarInscripcion (item, tipobaja) {
      this.bajainsc= {
        idtipobaja: 4,
        tipobaja: tipobaja,
        idinscripcion: item.idinscripcion
      }
      this.dialogbajainscripcion=true;
    },
    BajarInscripcion () {
      //if (await this.$refs.confirm.open('Confirmar Baja','Esta seguro de querer bajar la inscripción?')) {
        const baja = JSON.stringify({idalumno: this.edited.idalumno, idinscripcion: this.bajainsc.idinscripcion, tipobaja: this.bajainsc.tipobaja, idtipobaja: this.bajainsc.idtipobaja, usuario: this.usuario});
        axios.post("administracion/PostBajaInscripcion", baja, { headers: {"Content-Type": "application/json", }}).then((result) => {
          if(result.data.resultado===0){
            var param= JSON.stringify({idalumno: this.edited.idalumno });
            axios.post("administracion/PostGetAlumno", param, { headers: {"Content-Type": "application/json", }})
              .then((result) => {
                if(result.data.resultado===0){
                  this.edited= result.data.datos[0];
                  this.editedver= result.data.datos[1];
                  this.edited.usuario= this.usuario;
                  this.dialogbajainscripcion= false;
                  this.loading=false;
                }else{
                  this.loading = false;
                  this.MostrarMensaje("Error", result.data.resultadomensaje, false);
                }
            })
              .catch((error) => {
                this.loading = false;
                this.MostrarMensaje("Error", error, false);
            });
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        })
          .catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
        });
      //}
      
      //alert(item.idinscripcion+'|'+tipobaja);
    },
    getcolorestadoinsc (estado) {
      if (estado === 1) {return "green";}
      else if (estado === 2) {return "black";}
      else if (estado === 3) {return "blue";}
      else if (estado === 4) {return "red";}
      else if (estado === 5) {return "blue";}
      else if (estado === 6) {return "orange";}
    },
    async ActivarInscripcion (item) {
      if (await this.$refs.confirm.open('Confirmar Activación','Esta seguro de querer activar la inscripción bajada?')) {
        const activa = JSON.stringify({idalumno: this.edited.idalumno, idinscripcion: item.idinscripcion, tipobaja: 0, idtipobaja: 0, usuario: this.usuario});
        axios.post("administracion/PostActivaInscripcion", activa, { headers: {"Content-Type": "application/json", }}).then((result) => {
          if(result.data.resultado===0){
            var param= JSON.stringify({idalumno: this.edited.idalumno });
            axios.post("administracion/PostGetAlumno", param, { headers: {"Content-Type": "application/json", }})
              .then((result) => {
                if(result.data.resultado===0){
                  this.edited= result.data.datos[0];
                  this.editedver= result.data.datos[1];
                  this.edited.usuario= this.usuario;
                  this.loading=false;
                }else{
                  this.loading = false;
                  this.MostrarMensaje("Error", result.data.resultadomensaje, false);
                }
            })
              .catch((error) => {
                this.loading = false;
                this.MostrarMensaje("Error", error, false);
            });
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        })
          .catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
        });
      }
    },
    seleccionacuotacarrera () {
      var ia= 0;
      var anioactual= (new Date()).getFullYear()+1;
      this.listaanioscarreraalumno=[];
      var anioing= this.listacarrerasalumno.filter(c=> c.idcarrera===this.cuotaidcarrera)[0].anioingreso;
      if(anioing<=anioactual){
        for(ia=anioing;ia<=anioactual;ia++){
          this.listaanioscarreraalumno.push({anio: ia});
        }
      }else{
        for(ia=anioactual;ia<=anioing+1;ia++){
          this.listaanioscarreraalumno.push({anio: ia});
        }
      }
      this.cuotaanio= (new Date()).getFullYear();
    },
    getcolorestadocuota (estado) {
      if (estado === 'SIN ABONAR') {return "grey";}
      else if (estado === 'FACTURA GENERADA') {return "green";}
      else if (estado === 'FACTURA REGENERADA') {return "green";}
      else if (estado === 'FACTURA ABONADA') {return "blue";}
      else if (estado === 'FACTURA PARCIALMENTE ABONADA') {return "yellow";}
      else if (estado === 'FACTURA VENCIDA') {return "red";}
      else if (estado === 'FACTURA ANULADA') {return "black";}
    },
    resetearclave () {
      
    }
},
  computed: {
    fechalocalfecnac: function () {
      if (this.edited.fechanac != null && this.edited.fechanac != "") {
        var fecha = new Date(this.edited.fechanac);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalfdesde: function () {
      if (this.editednov.desde != null && this.editednov.desde != "") {
        var fecha = new Date(this.editednov.desde);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalfhasta: function () {
      if (this.editednov.hasta != null && this.editednov.hasta != "") {
        var fecha = new Date(this.editednov.hasta);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocallicdesde: function () {
      if (this.editedlic.desde != null && this.editedlic.desde != "") {
        var fecha = new Date(this.editedlic.desde);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocallichasta: function () {
      if (this.editedlic.hasta != null && this.editedlic.hasta != "") {
        var fecha = new Date(this.editedlic.hasta);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    }
  },
};
</script>
<style>

.textofilagrilla {
  font-size: 0.680rem !important;
  height: 3px !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.fullpantalla{
    height: 100% !important;
    width: 100% !important;
}

.letraroja {
  color: red;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>